/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { cn } from "../../lib/utils";

export type BadgeTone = "success" | "warning" | "error" | "info" | "neutral";

const TONES: Record<BadgeTone, string> = {
  success: "text-success bg-success-bg border-success-border",
  warning: "text-warning bg-warning-bg border-warning-border",
  error: "text-error bg-error-bg border-error-border",
  info: "text-info bg-info-bg border-info-border",
  neutral: "text-text-secondary bg-bg-hover border-border",
};

export function Badge({
  tone = "neutral",
  className,
  children,
}: {
  tone?: BadgeTone;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
